import { untilDestroyed, UntilDestroy } from '@ngneat/until-destroy';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApplicationStage, LinkingStatus } from 'common';
import { ApplicationData } from '../application.model';

@UntilDestroy()
@Component({
    selector: 'ifb-application-app-bar-expanded',
    templateUrl: './application-app-bar-expanded.component.html',
    styleUrls: ['./application-app-bar-expanded.component.scss'],
    standalone: false
})
export class ApplicationAppBarExpandedComponent implements OnInit {
  data: ApplicationAppBarExpandedComponentData;
  message: string;
  showError: boolean;
  showWarning: boolean;
  showSuccess: boolean;
  activeStepNumber: number;

  constructor(private readonly route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.data.pipe(untilDestroyed(this))
      .subscribe((data: ApplicationAppBarExpandedComponentData) => { 
        this.data = data; 
        this.initData(this.data.application);
      });
  }

  private initData(data: ApplicationData): void {
    const application = this.data.application;

    switch (application.stage) {
      case ApplicationStage.New:
      case ApplicationStage.ApplicationCreated:
      case ApplicationStage.MODALProcessing:
      case ApplicationStage.MODALError:
      case ApplicationStage.DeclinedReview:
      case ApplicationStage.ConditionalApprovalNAICSCheck:
      case ApplicationStage.ApplicationIncomplete:
        this.activeStepNumber = 1;
        break;
      case ApplicationStage.ConditionalOffer:
      case ApplicationStage.PreUnderwriting:
      case ApplicationStage.Underwriting:
      case ApplicationStage.UnderwritingLitigation:
      case ApplicationStage.UnderwritingReview:
        this.activeStepNumber = 2;
        break;
      case ApplicationStage.UnderwritingMissingInfo:
        this.activeStepNumber = 2;
        this.message = 'Check for missing information in application.';
        this.showError = true;
        break;
      case ApplicationStage.Approved:
        this.activeStepNumber = 3;
        this.message = 'Application approved. Send out offer.';
        this.showSuccess = true;
        break;
      case ApplicationStage.DirectProposal:
      case ApplicationStage.Accepted:
      case ApplicationStage.UnderwritingCall:
      case ApplicationStage.Closing:
      case ApplicationStage.ClosingReview:
      case ApplicationStage.SalesReview:
      case ApplicationStage.ClosingIncomplete:
      case ApplicationStage.PendingSignature:
      case ApplicationStage.Open:
      case ApplicationStage.PendingRenewal:
      case ApplicationStage.Frozen:
      case ApplicationStage.Closed:
      case ApplicationStage.Dormant:
      case ApplicationStage.Expired:
      case ApplicationStage.NotInterested:
        this.activeStepNumber = 3;
        break;
      case ApplicationStage.Declined:
        this.activeStepNumber = 3;
        this.message = 'Application declined.';
        this.showWarning = true;
        break;
    }

    if (data.bankLinkStatus !== LinkingStatus.Linked) {
      this.message = 'Bank link required to continue application process.';
      this.showError = true;
    }
  }
}

export interface ApplicationAppBarExpandedComponentData {
  application: ApplicationData;
}
